import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { PwcsInlineSvgComponent } from 'src/app/shared/components/pwcs-inline-svg/pwcs-inline-svg.component';
import { ModalComponent } from '@tecalisdev/infinity';
import { CONNECTION_TYPE } from 'src/app/user-identification/models/user-identification';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-modal-connections-instructions',
	imports: [ModalComponent, TranslatePipe, PwcsInlineSvgComponent],
	templateUrl: './modal-connections-instructions.component.html',
	styleUrl: './modal-connections-instructions.component.scss',
})
export class ModalConnectionsInstructionsComponent {
	private trans = inject(TranslateService);

	@Input() isVisible: boolean = false;
	@Input() connectionType: CONNECTION_TYPE;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public CONNECTION_TYPE = CONNECTION_TYPE;

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
